import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import { LanguagesInterface, responseInterface } from "@/types";
import api from "@/apiClient";

@Module
export default class LanguagesModule extends VuexModule {
  private globalLoader = false;
  private languages: LanguagesInterface[] = [];
  private activeLanguage: LanguagesInterface = { id: 0, name: "", code: "", src: "" };

  @Action
  public async LoadLanguages(): Promise<void> {
    this.setGlobalLoader(true);

    try {
      const response: responseInterface = await api.languages.fetch();

      if (response.statusCode !== 200 || !Array.isArray(response.data)) {
        throw new Error("Invalid language data response");
      }

      this.setLanguages(response.data);
    } catch (error) {
      console.error("Failed to load languages:", error);
    } finally {
      this.setGlobalLoader(false);
    }
  }

  @Action
  public SetLanguage(active: LanguagesInterface): void {
    this.setActiveLanguage(active);
  }

  @Action
  public SetLanguageByCode(code: string): void {
    const match = this.languages.find((lang) => lang.code === code);

    if (match) {
      this.SetLanguage(match);
    }
  }

  @Mutation
  private setLanguages(languages: LanguagesInterface[]) {
    this.languages = languages;
  }

  @Mutation
  private setActiveLanguage(active: LanguagesInterface) {
    this.activeLanguage = active;
  }

  @Mutation
  private setGlobalLoader(loader: boolean) {
    this.globalLoader = loader;
  }

  get getLanguages(): LanguagesInterface[] {
    return this.languages;
  }

  get getActiveLanguage(): LanguagesInterface {
    return this.activeLanguage;
  }

  get getActiveLanguageCode(): string {
    return this.activeLanguage.code;
  }

  get getValidLanguageCodes(): Set<string> {
    return new Set(this.languages.map((l: any) => l.code));
  }

  get getGlobalLoader(): boolean {
    return this.globalLoader;
  }
}
